import { Component, Vue } from 'vue-property-decorator';
/**
 * Structural component that provides a basic container for content.
 * It is extensible via CSS for styling customization such as background, borders, etc.
 */
@Component
export default class SdCard extends Vue {
   
}
